<template>
  <k-video-grid :items="sorted" storage-key="multiview" :max-entries="100">
    <template #default="{ item }">
      <item :data="item" :timestamp="ts"></item>
    </template>
  </k-video-grid>
</template>

<script>
import Item from './Item'
import moment from 'moment';

export default {
  components: {
    Item
  },
  data () {
    var start_date = moment().startOf('day').toDate();
    var end_date = moment().endOf('day').toDate();
    return {
      events: [],
      filters: {
        daterange: {
          start: start_date,
          end: end_date
        },

        states: ["active"]
      },
      ts: this.$store.state.timestamp,
      interval: undefined,
      on_init_ref: undefined,
      on_events_ref: undefined,
      on_event_update_ref: undefined
    }
  },
  mounted: function() {
    this.$store.dispatch("get_profile").then(() => {
	    this.$nextTick(() => {
	      this.connect_ws();
	    });
		}, () => {});
    var self = this;
    self.ts = self.$store.state.timestamp || moment().unix();
    this.interval = setInterval(() => {
      self.ts = self.$store.state.timestamp;
    },10000);
  },
  computed: {
    sorted() {
      var self = this;
      var events = this.events;
      var account = this.$store.state.account;
      if(typeof(account) != "undefined" && account.email.indexOf("@kepit.fi") == -1) {
        events = _.filter(events, (event) => {
          return event.channel_id != 398;
        });
      }
      events = _.filter(events, (event) => { return _.indexOf(this.multiview_filters, event.uuid) != -1; });
      return _.sortBy(events, function(o) { return [o.cached_start_time] })
    },
    multiview_filters () {
      return this.$store.state.account.meta.multiview_event_filter || [];
    }
  },
  methods: {
    is_running(e) {
      return e.cached_start_time <= this.ts && e.cached_end_time >= this.ts;
    },
    filterEvents () {
      var self = this;
      var _filters = _.cloneDeep(this.filters);
      if(typeof(_filters.daterange.start) != "undefined") {
        _filters.daterange.start = moment(_filters.daterange.start).startOf('day').unix();
      }
      if(typeof(_filters.daterange.end) != "undefined") {
        _filters.daterange.end = moment(_filters.daterange.end).endOf('day').unix();
      }
      this.channel.push("filter_reply", _filters)
        .receive("ok", (msg) => {
          self.ts = self.$store.state.timestamp;
          self.events = msg.events;
        })
        .receive("error", (msg) => {
          console.log("Event filter failed");
        });

//      this.channel.push("filter", _filters);
    },
    connect_ws () {
      var self = this;
      this.channel = this.$cloudserver.channel("events:all", false);
      this.on_init_ref = this.channel.on("init", function(msg) {
        self.filterEvents();
      });
/*      this.on_events_ref = this.channel.on("events", function(msg) {
        self.ts = self.$store.state.timestamp;
        self.events = msg.events;
      });*/
      this.on_event_update_ref = this.channel.on("event-update", function(msg) {
        self.filterEvents();
      });
      this.channel.join();
    }
  },
  beforeDestroy: function() {
    clearInterval(this.interval);
  }
}
</script>
<style>
.plyr--video {
  height: 100%;
  min-width: 100px;
}
.plyr--video .plyr__video-wrapper {
  top: 50%;
  transform: translateY(-50%);
}
.plyr--video .plyr__controls {
  padding: 20px 2px 2px;
}
</style>
